import { SIZES } from 'common/constants/sizes';
import { getColor } from 'common/constants/_colors';
import styled from 'styled-components';

export const StyledEmptyStateContainer = styled.div`
  width: 100%;
  padding-top: 5rem;
  padding-bottom: 5rem;
  display: flex;
  justify-content: center;
`;

export const StyledGraphEmptyState = styled.div`
  width: 36rem;
  text-align: center;
  & > main {
    margin-top: 1rem;
    color: ${getColor('shuttleGray')};
    & > .primary {
      font-size: ${SIZES['x-x-large']};
      margin-bottom: 0.5rem;
    }
    & > .secondary {
      font-size: ${SIZES['large']};
    }
  }
`;
